module.exports = __webpack_public_path__ + "img/logo_header.de39eebd.png";